// ARQUIVO GERADO AUTOMATICAMENTE por scripts/generate-build-version.js
// Não editar manualmente.
// O tipo explícito `string` é necessário: sem ele o TS infere um literal e
// acusa erro nas comparações feitas em appUpdateChecker.ts.
export const BUILD_VERSION: string = '8.2.0-mw2u5fys'
